// ===== Tibetan Calendar inline 「Today」兜底校正脚本（独立资产）=====
// 由 sections/announcement-bar.liquid 通过
//   <script src="{{ 'tcal-today.js' | asset_url }}" defer="defer"></script>
// 引入。设计分工：
//   1) 服务端（Liquid）已用 shop.metafields.custom.tibetan_today 渲染出「店铺时区的今天」；
//   2) 本脚本只在【服务端没渲染出今天】时（metafield 过期/为空/写入任务停摆）才去
//      calendar.gandhanra.art 取一次 JSON 校正 —— 因此绝大多数页面加载零请求、零闪烁。
// 日期口径：一律用 span 上的 data-tcal-shopdate（Liquid 的 'now' = 店铺时区），
//           与 metafield 的日期同源，避免访客本地时区造成两套日期。
// ⚠️ 本文件与 section 里那行 <script src> 都不能删；删掉后公告栏会停在 metafield/占位文本。
(function () {
  var el = document.getElementById('tcal-today-text');
  if (!el) return;

  function pad(n) { return String(n).padStart(2, '0'); }
  function fmt(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function render(entry, day) {
    el.innerHTML = '<strong>&#9784; Today</strong> &nbsp;Month ' + entry.tm + ', Day ' + entry.tday +
                   ' &middot; ' + entry.ty + ' ' + entry.yr;
    el.dataset.tcalDate = day;
  }

  // 店铺时区的今天：服务端直接用 Liquid 'now' 渲染进来；取不到才退回访客本地日期
  var day = el.dataset.tcalShopdate || fmt(new Date());

  // 服务端已渲染出今天（文案里带 "Today"）或本脚本已校正过 → 直接返回，不发请求
  if (el.dataset.tcalDate === day || /Today/.test(el.textContent || '')) return;

  fetch('https://calendar.gandhanra.art/data/' + day.slice(0, 4) + '.json', { cache: 'no-cache' })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var e = (data || []).find(function (d) { return d.d === day; });
      if (e) render(e, day);
    })
    .catch(function () { /* 失败保留服务端渲染/占位文本 */ });
})();
